import { styled, TextField } from '@mui/material';

const StyledTextField = styled(TextField)(({ theme }) => ({
  // Let the component inherit all styles from the theme's MuiOutlinedInput
  // The theme already defines comprehensive styling for inputs including:
  // - Border radius (8px)
  // - Padding (16px 12px)
  // - Font family, size, weight, and letter spacing
  // - Line height and color
  // This ensures consistency with other inputs in the application
}));

export default StyledTextField;
